<template>
  <div class="layou">
    <div class="layout-menu-left">
      <!-- <div class="layout-profile">
        <img src="../assets/img/logo.png">
      </div> -->
      <!-- 后台管理菜单 -->
      <el-menu :router=true :unique-opened=true class="el-menu-root" :default-active="defaultActive" :style="{height:number + 'px'}">
        <!-- <el-menu-item index="/" ><i class="fa fa-fw fa-home"></i>首页</el-menu-item> -->
        <el-menu-item index="/appointment/appointment" v-permission="'1'" title='预约管理'><img src="../assets/img/appointment.png" alt="">
          预约管理</el-menu-item>
        <el-menu-item index="/appointmentList/appointmentList" v-permission="'15'"><img src="../assets/img/reserve.png" alt="">
          预约列表</el-menu-item>
        <el-menu-item index="/appointmentTimes/appointmentTimes" v-permission="'16'"><img src="../assets/img/survey.png" alt="">
          预警管理</el-menu-item>
        <el-menu-item index="/project/project" v-permission="'2'"><img src="../assets/img/project.png" alt="">
          项目管理</el-menu-item>
        <el-menu-item index="/instrument/instrument" v-permission="'3'"><img src="../assets/img/instr.png" alt="">
          仪器管理</el-menu-item>
        <el-menu-item index="/instrument/instrumentTime" v-permission="'17'"><img src="../assets/img/instr.png" alt="">
          项目预警</el-menu-item>
        <el-menu-item index="/part/part" v-permission="'4'"><img src="../assets/img/part.png" alt="">部位管理
        </el-menu-item>
        <el-menu-item index="/account/account" v-permission="'5'"><img src="../assets/img/account.png" alt="">账号管理</el-menu-item>
        <el-menu-item index="/user/user" v-permission="'6'"><img src="../assets/img/user.png" alt="">操作人管理
        </el-menu-item>
        <el-menu-item index="/roster/roster" v-permission="'7'"><img src="../assets/img/schedule.png" alt="">当月排班
        </el-menu-item>
        <el-submenu index="/scanCode/scanLIst" v-permission="'8'">
          <template slot="title">
            <img src="../assets/img/scan.png" alt="">
            <span>扫码管理</span>
          </template>
          <el-menu-item index="/scanCode/scanLIst" v-permission="'8'">大众点评</el-menu-item>
          <!-- <el-menu-item index="/scanCode/scanAccount" v-permission="'11'">新氧</el-menu-item> -->
        </el-submenu>
        <el-submenu index="1" v-permission="'13'">
          <template slot="title">
            <img src="../assets/img/survey.png" alt="">
            <span>问卷调查</span>
          </template>
          <el-menu-item :index="'/questionnaire/shQuestion'" v-permission="'14'">皮肤科问卷调查</el-menu-item>
          <el-menu-item :index="'/questionnaire/bjQuestion'" v-permission="'37'">北京问卷调查</el-menu-item>
          <el-menu-item :index="'/questionnaire/wzQuestion'" v-permission="'38'">温州问卷调查</el-menu-item>
          <el-menu-item index="/questionnaire/question" v-permission="'36'">外科问卷调查</el-menu-item>
          <!-- <el-menu-item index="/questionnaire/code" v-permission="'14'">健康码</el-menu-item> -->
        </el-submenu>
        <el-menu-item index="/draftBox/draftBox" v-permission="'12'"><img src="../assets/img/draft.png" alt="">
          草稿箱</el-menu-item>
        <el-submenu index="/role" v-permission="'9'">
          <template slot="title">
            <img src="../assets/img/user.png" alt="">
            <span>角色权限</span>
          </template>
          <el-menu-item index="/role/webUser" v-permission="'10'">后台用户</el-menu-item>
          <el-menu-item index="/role/roleManagement" v-permission="'11'">后台角色</el-menu-item>
        </el-submenu>

        <el-submenu index="/customerReception" v-permission="'18'">
          <template slot="title">
            <img src="../assets/img/user.png" alt="">
            <span>客户接待</span>
          </template>
          <el-menu-item index="/customerReception/frontAll/frontDesk" v-permission="'19'">前台</el-menu-item>
          <el-menu-item index="/customerReception/customers/service" v-permission="'20'">客服</el-menu-item>
          <el-menu-item index="/customerReception/nurseAll/nurse" v-permission="'23'">护士</el-menu-item>
          <el-menu-item index="/customerReception/receptionAll/reception" v-permission="'24'">客服接待查询</el-menu-item>
          <el-menu-item index="/customerReception/serviceAll/serviceStatus" v-permission="'21'">客服状态</el-menu-item>
          <el-menu-item index="/customerReception/punchStatus" v-permission="'22'">打卡状态</el-menu-item>
        </el-submenu>
        <el-submenu index="/registrationForm" v-permission="'26'">
          <template slot="title">
            <img src="../assets/img/user.png" alt="">
            <span>登记表</span>
          </template>
          <el-menu-item index="/registrationForm/registration" v-permission="'27'">美容外科手术表</el-menu-item>
          <el-menu-item index="/registrationForm/injection" v-permission="'28'">美容外科耗材表</el-menu-item>
          <el-menu-item index="/registrationForm/dermatology" v-permission="'29'">美容皮肤科登记表</el-menu-item>
          <el-menu-item index="/registrationForm/consumables" v-permission="'30'">美容皮肤科耗材表</el-menu-item>
          <el-menu-item index="/registrationForm/logData" v-permission="'34'">日志</el-menu-item>
          <el-menu-item index="/registrationForm/setSurgical" v-permission="'31'">设置-美容外科手术表</el-menu-item>
          <el-menu-item index="/registrationForm/setSkin" v-permission="'32'">设置-美容皮肤科手术表</el-menu-item>
          <el-menu-item index="/registrationForm/setProduction" v-permission="'33'">设置-产品</el-menu-item>
          <el-menu-item index="/registrationForm/setDiagnosis" v-permission="'35'">设置-诊断手术名称</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="layout-page">
      <div class="layout-top">
        <!-- <img src="../assets/img/title.png" alt=""> -->
        <div>{{msg}}</div>
        <div>
          <el-button v-if="flag" style="margin-right: 30px;font-size:18px;" plain @click="changeSys">切换院区</el-button>
          <el-dropdown @command="handleCommand" trigger="click">
            <span class="el-dropdown-link">
              {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="info">修改密码</el-dropdown-item> -->
              <el-dropdown-item divided command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="layout-page-content" :class="{ offset: showNotify }">
        <transition name="vux-pop-in" mode="out-in" appear>
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import permission from '../directives/permission/index'
import TaskNofity from "./nofity/nofity";
export default {
  components: {
    TaskNofity
  },
  directives: {
    permission
  },
  name: "Main1",
  data() {
    return {
      showNotify: false,
      notifyCount: 0,
      userName: Lockr.get('userName'),
      systemType: Lockr.get('systemType'),
      number: '',
      jurisdictionId: Lockr.get("jurisdictionId"),
      jurisdictionName: Lockr.get("jurisdictionName"),
      areaType: Lockr.get("areaType"),
      flag: false,
      msg: '',
    }
  },
  computed: {
    defaultActive() {
      return this.$route.path
    },
  },
  mounted() {
    // el-menu的高度=页面高度-图标高度
    this.number = document.documentElement.scrollHeight
    if (this.jurisdictionId == 'null' || this.jurisdictionName == '医务科' || this.jurisdictionName == '皮肤科' || this.jurisdictionName == '外科') {
      this.flag = false
    } else {
      this.flag = true
    }
  },
  methods: {
    changeSys() {
      router.replace('/category')
    },
    notifyUpdate(count) {
      this.notifyCount = count
    },
    notify() {
      this.showNotify = !this.showNotify
    },
    handleCommand(command) {
      console.log(command)
      if (command == 'info') {
        this.info();
      } else if (command == 'exit') {
        this.exit();
      }
    },
    info() {
      router.push('/home/info');
    },
    exit() {
      api.request("personnel/personnelExit", {
        token: Lockr.get("yyToken")
      }, (res) => {
        // Lockr.flush()
        Lockr.rm('yyToken');
        Lockr.rm('userId');
        Lockr.rm('userName');
        Lockr.rm('empId');
        Lockr.rm('permission');
        Lockr.rm('systemType');
        Lockr.rm('clientType');
        Lockr.rm('jurisdictionId');
        Lockr.rm('jurisdictionName');
        Lockr.rm('mobile');
        Lockr.rm('sign');
        router.push('/login')
      }, (err) => { })
    }

  },
}
</script>
<style scoped>
.fa {
  font-size: 1.2em;
  margin-right: 5px;
}
</style>

<style>
.layout-menu-left {
  width: 200px;
  min-height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  padding-top: 15px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #7ac7f4 0%, #5c43db 100%);
  /* border-radius: 0px 19px 0px 0px !important; */
}

.layout-profile {
  background-color: #fff;
  text-align: center;
  /*padding: 25px 0px;*/
}

.layout-profile > img {
  width: 92px;
  padding: 10px 30px;
  /* height: 124px; */
  display: block;
  margin: 0 auto;
  background: #ffffff;
}

.layout-profile .el-dropdown {
  color: #ccc;
}

.layout-page {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 200px;
  /* bottom: 0px; */
  /*min-height: 950px;*/
  /*
        overflow-y: auto;*/
  /* background-color: #f3f3f4;*/
}

.layout-top {
  line-height: 60px;
  height: 60px;
  padding: 0px 15px;
  text-align: right;
  /* background: red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.layout-page-content {
  padding: 0px 15px 15px;
}

/*.layout-page-content.offset {
        margin-right: 260px;
    }*/

.layout-page-right {
  width: 260px;
  position: absolute;
  background-color: #fff;
  top: 50px;
  right: 0;
  bottom: 0;
  border-left: solid 1px #f3f3f4;
}

.layout-page-heading {
  background-color: #fff;
  margin: 0px -15px;
  padding: 5px 25px 5px;
}

.layout-page-heading h3 {
  margin: 0;
  line-height: 45px;
  font-weight: normal;
}

.layout-page-heading-action {
  margin-top: 15px;
  text-align: right;
}

.layout-page-box {
  background-color: #ffffff;
  padding: 15px 20px 20px 20px;
  margin: 15px 0px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  transition: 0.2s;
}

.layout-page-box:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.el-menu-root img {
  width: 19px;
  margin: 0 8px 0 10px;
}
.el-menu-root {
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-dropdown-link {
  font-size: 18px;
}

.el-icon-arrow-down {
  font-size: 14px;
}
</style>
